module.exports = __webpack_public_path__ + "img/DE01463.88004d08.png";